export const people = 'People';
export const vehicles = 'Vehicles';
export const starships = 'Starships';

export const questions = {
  [people]: 'Who is this character?',
  [vehicles]: 'Do you recognize this vehicle?',
  [starships]: 'Do you recognize this starship?',
};

export const gameRules = {
  [people]: 'You have one minute (1m) to answer as many questions as possible. During the game on each question you need to select who from Star Wars is showed on the left from available options',
  [vehicles]: 'You have one minute (1m) to answer as many questions as possible. During the game on each question you need to select what vehicle from Star Wars is showed on the left from available options',
  [starships]: 'You have one minute (1m) to answer as many questions as possible. During the game on each question you need to select what starship from Star Wars is showed on the left from available options'
}